const queryParamsReducer = (state = {
},action) => {
    switch(action.type) {
        case  'SET_QUERY_PARAMS': {
            return {
                 ...action.payload
            }
        }
 
        default :{
            break;
          }
    }
    return state;
}

export default queryParamsReducer;